import React, { useEffect, useState } from "react";
import api from "../../api";
import "./AssetValueSummary.css";

// Asset value totals from GET /products/value-summary -- computed in SQL
// over EVERY asset the caller's products:view scope allows (optionally one
// unit), never summed from the page's own (filtered/paginated) rows.
//   Original Purchase Value = every asset, discarded included (never reduced)
//   Active Asset Value      = assets not discarded
//   Discarded Value         = purchase value of discarded assets
//   Recovered (Auction/Sale)= disposal_amount of discarded assets
// Hidden entirely when the endpoint is unavailable (backend not deployed
// yet) -- never shows made-up zeros. `refreshKey` re-fetches after a
// discard/edit on the host page.
const inr = (v) => {
  const n = Number(v || 0);
  return `₹${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export default function AssetValueSummary({ unitId, refreshKey }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const params = unitId ? { unit_id: unitId } : undefined;
    api
      .get("/products/value-summary", { params })
      .then((res) => { if (!cancelled) setSummary(res.data || null); })
      .catch(() => { if (!cancelled) setSummary(null); });
    return () => { cancelled = true; };
  }, [unitId, refreshKey]);

  if (!summary) return null;

  const items = [
    { key: "original", label: "Original Purchase Value", value: inr(summary.original_purchase_value), note: `${summary.total_assets} asset(s)` },
    { key: "active", label: "Active Asset Value", value: inr(summary.active_asset_value), note: `${summary.active_assets} active` },
    { key: "discarded", label: "Discarded Value", value: inr(summary.discarded_purchase_value), note: `${summary.discarded_assets} discarded` },
  ];
  if (summary.disposal_tracking_enabled) {
    items.push({ key: "recovered", label: "Recovered (Auction / Sale)", value: inr(summary.recovery_value), note: "from discarded assets" });
  }

  return (
    <section className="avs-strip" aria-label="Asset value summary">
      {items.map((i) => (
        <div key={i.key} className={`avs-item avs-${i.key}`}>
          <span className="avs-label">{i.label}</span>
          <strong className="avs-value">{i.value}</strong>
          <small className="avs-note">{i.note}</small>
        </div>
      ))}
    </section>
  );
}
